module.exports = __webpack_public_path__ + "static/media/switch-icon.bf213c6b.svg";